import React from 'react';
import { ContactForm } from '../../components';
import { FaLinkedinIn, FaInstagram, FaFacebookF, FaTwitter, FaWhatsapp, FaEnvelope } from 'react-icons/fa';

const ContactFormSection = () => {

  return (
    <section className="section-padding contact-form-section" id="contact-form">
      <div className="container">
        <div className="row">
          <div className="col-lg-8 mb-5 mb-lg-0">
            <ContactForm
              title="Send Us a Message"
              subtitle="Ready to start your project?"
              showTitle={true}
            />
          </div>
          <div className="col-lg-4">
            <div className="contact-sidebar">
              <div className="map-container mb-4">
                <h5 className="mb-3">Our Location</h5>
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3721.123456789!2d72.8311!3d21.1702!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be04e59411d1563%3A0xfe4558290938b042!2sSurat%2C%20Gujarat%2C%20India!5e0!3m2!1sen!2sin!4v1234567890"
                  width="100%"
                  height="300"
                  style={{ border: 0, borderRadius: '12px' }}
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="GrowthVibe Location - Surat, Gujarat"
                ></iframe>
              </div>

              <div className="quick-contact mb-4">
                <h5 className="mb-3">Quick Contact</h5>
                <div className="row g-2">
                  <div className="col-12">
                    <div className="quick-contact-item">
                      <FaWhatsapp className="quick-contact-icon" />
                      <div>
                        <p className="mb-1">WhatsApp</p>
                        <a href="https://wa.me/917861083648" target="_blank" rel="noopener noreferrer">
                          +91 78610 83648
                        </a>
                      </div>
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="quick-contact-item">
                      <FaEnvelope className="quick-contact-icon" />
                      <div>
                        <p className="mb-1">Email</p>
                        <a href="mailto:growthvibe2406@gmail.com">
                          growthvibe2406@gmail.com
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="social-links">
                <h5 className="mb-3">Follow Us</h5>
                <div className="social-icons">
                  <a href="https://linkedin.com/company/growthvibe" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
                    <FaLinkedinIn />
                  </a>
                  <a href="https://instagram.com/growthvibe" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                    <FaInstagram />
                  </a>
                  <a href="https://facebook.com/growthvibe" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
                    <FaFacebookF />
                  </a>
                  <a href="https://twitter.com/growthvibe" target="_blank" rel="noopener noreferrer" aria-label="Twitter">
                    <FaTwitter />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactFormSection;